export default {
  parent_user: state => {
    return state.parent_user
  }
}